export const PAYMENT_METHODS = {
    BANK_TRANSFER: "B",
    CHEQUE: "C",
    OVERSEAS_BANK: "OB",
    FASTER_PAYMENT_SYSTEM: "FPS",
    PAYNOW: "PN",
    DUITNOW: "DN"
};
